import { fork, put, takeLatest } from 'redux-saga/effects';
import {
    ACTIVATE_IWOCAPAY_DASHBOARD,
    DASHBOARD_READY,
    DASHBOARD_ERROR,
    REFRESH_APPLICATIONS,
    UPDATE_PLANS
} from './Dashboard.actions';
import {
    API_GET_ACCOUNTS,
    API_GET_CUSTOMER_STATE,
    API_GET_APPLICATION,
    API_POST_DECLINE_APPLICATION,
    API_GET_PRODUCT_OFFERS,
    API_POST_FORMAL_OFFERS
} from '../../../api/lendingAPI/LendingAPI.actions';
import {
    API_GET_IWOCAPAY_PAY_LINKS,
    API_GET_IWOCAPAY_CAPTURED_PAYMENTS
} from '../api/LendingAPI.actions';
import {
    putAndWaitHandleAllAPIError,
    putAndHandleAPIError,
    selectAPI
} from '../../../api/API.sagas';
import { setEcomOrderIdToQueryParams } from '../../drawDown/DrawDownHelper';
import {
    getIwocaPayApplication,
    getLatestUnfundedPayLink,
    getIwocaPayProductOffers,
    getSuggestedProduct,
    checkStatusIsDeclined,
    getProductDeclineUid
} from './Dashboard.helpers';

export const iwocaPayDashboardSagaWorkers = [
    fork(iwocaPayDashboardPageWorker),
    fork(iwocaPayRefreshApplications)
];

function* iwocaPayDashboardPageWorker() {
    yield takeLatest(ACTIVATE_IWOCAPAY_DASHBOARD, function* () {
        try {
            yield putAndWaitHandleAllAPIError([
                { type: API_GET_CUSTOMER_STATE },
                { type: API_GET_APPLICATION },
                { type: API_GET_ACCOUNTS },
                { type: API_GET_IWOCAPAY_PAY_LINKS },
                { type: API_GET_IWOCAPAY_CAPTURED_PAYMENTS }
            ]);

            const { iwocapay_pay_links, iwocapay_captured_payments } =
                yield selectAPI();
            const latestUnfundedPayLink =
                getLatestUnfundedPayLink(iwocapay_pay_links);

            const orderId = latestUnfundedPayLink?.order?.order_id;
            if (orderId) {
                yield setEcomOrderIdToQueryParams(orderId);
            }

            let { accounts, application } = yield selectAPI();

            const iwocaPayApplication = getIwocaPayApplication(application);

            if (iwocaPayApplication && iwocaPayApplication.status === 'open') {
                yield putAndWaitHandleAllAPIError([
                    { type: API_GET_PRODUCT_OFFERS }
                ]);

                let { product_offers } = yield selectAPI();

                const suggestedProduct = getSuggestedProduct(product_offers);
                const isDeclined = checkStatusIsDeclined(suggestedProduct);

                if (isDeclined) {
                    const productDeclineUid =
                        getProductDeclineUid(suggestedProduct);
                    const declineStatus =
                        suggestedProduct.status === 'hard_declined'
                            ? 'Hard Declined'
                            : 'Soft Declined';

                    yield putAndHandleAPIError({
                        type: API_POST_DECLINE_APPLICATION,
                        body: JSON.stringify({
                            data: {
                                status: declineStatus,
                                product_type_decline_uid: productDeclineUid
                            }
                        })
                    });

                    yield putAndWaitHandleAllAPIError([
                        { type: API_GET_APPLICATION },
                        { type: API_GET_ACCOUNTS },
                        { type: API_GET_PRODUCT_OFFERS }
                    ]);

                    const {
                        application: updatedApplication,
                        accounts: updatedAccounts,
                        product_offers: updatedProductOffers
                    } = yield selectAPI();

                    application = updatedApplication;
                    accounts = updatedAccounts;
                    product_offers = updatedProductOffers;
                }

                const iwocaPayProductOffers =
                    getIwocaPayProductOffers(product_offers);

                if (iwocaPayProductOffers && iwocaPayProductOffers.length > 0) {
                    yield putAndHandleAPIError({
                        type: API_POST_FORMAL_OFFERS,
                        body: JSON.stringify({
                            data: {
                                offer_ids: iwocaPayProductOffers.map(
                                    (offer) => offer.id
                                )
                            }
                        })
                    });

                    yield putAndWaitHandleAllAPIError([
                        { type: API_GET_ACCOUNTS },
                        { type: API_GET_APPLICATION }
                    ]);

                    const {
                        application: updatedApplication,
                        accounts: updatedAccounts
                    } = yield selectAPI();

                    application = updatedApplication;
                    accounts = updatedAccounts;
                }
            }

            const { customer_state } = yield selectAPI();

            yield put({
                type: DASHBOARD_READY,
                accounts: accounts.accounts,
                application,
                customer_state,
                payLinks: iwocapay_pay_links,
                capturedPayments: iwocapay_captured_payments
            });
        } catch (e) {
            yield put({ type: DASHBOARD_ERROR });
        }
    });
}

function* iwocaPayRefreshApplications() {
    yield takeLatest(REFRESH_APPLICATIONS, function* () {
        try {
            yield putAndWaitHandleAllAPIError([
                { type: API_GET_ACCOUNTS },
                { type: API_GET_APPLICATION }
            ]);

            const { accounts, application } = yield selectAPI();

            yield put({
                type: UPDATE_PLANS,
                accounts: accounts.accounts,
                application: application
            });
        } catch (e) {
            yield put({ type: UPDATE_PLANS });
        }
    });
}
